import { Component, Type, Input, ViewChild, EnvironmentInjector, ViewContainerRef, OnInit, Injector, EventEmitter, Output, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';

import { FieldFactoryLocator } from '@core/custom-forms/factories/field-factory-locator';
import { FieldFactory } from '@core/custom-forms/factories/field-factory.interface';
// import { SettingsCustomFormFieldData } from "@core/custom-forms/models/settings/settings-custom-form-field-data.class";

import { CustomFormFieldSubmission } from '@core/objects/form';
@Component({
  selector: 'custom-forms-dynamic-view-field-host',
  template: '<ng-template #dynamicViewFieldContainer></ng-template>',
})
export class DynamicViewFieldHostComponent implements OnInit, OnChanges, OnDestroy {
    @Input() fieldSubmission: CustomFormFieldSubmission;
    // @Input() value = new EventEmitter<FieldDataInterface>();
    @ViewChild('dynamicViewFieldContainer', { read: ViewContainerRef, static: true }) dynamicViewFieldContainer: ViewContainerRef;
  
    // protected fieldDataInstance: SettingsCustomFormFieldData; 
    protected componentType: Type<any>; 
    protected componentRef: any;
    constructor(public viewContainerRef: ViewContainerRef,private injector: Injector,
        private fieldLocator: FieldFactoryLocator,
        private environmentInjector: EnvironmentInjector) {}
  
    ngOnInit() {
      this.loadComponent();
    }

    ngOnChanges(changes: SimpleChanges) {

      // if (changes.fieldSubmission && !changes.fieldSubmission.isFirstChange()) {
      //     // detect if field type in this position to create a new component in place of the old one.
      //     // replace components in same position without cleaning the container ref does not work 
      //     if(changes.field.previousValue.type != changes.field.currentValue.type || 
      //         changes.field.previousValue.id != changes.field.currentValue.id     
      //     ){
      //         this.dynamicViewFieldContainer.clear();
      //         this.loadComponent();
      //     } else {
      //         this.updateField(); // maybe need to update the field, but seems to work.
      //     }
      // }
    }

    ngOnDestroy(): void {
        // Clean up the created component and instance
        // this.fieldDataInstance = null;
        this.componentType = null;
    }

    private loadComponent() {
      const fieldFactory: FieldFactory = this.fieldLocator.get(this.fieldSubmission.field.type);
      // this.fieldDataInstance = fieldFactory.createFillFormFieldData(this.fieldSubmission.field); 
      this.componentType  = fieldFactory.getViewComponentType();
      this.componentRef = this.dynamicViewFieldContainer.createComponent(this.componentType, {
        injector: this.injector,
        environmentInjector: this.environmentInjector
      });
      
      this.updateField();
        // Listen to changes from the component and emit them
      // (this.componentRef.instance as any).fieldChange.subscribe((updatedField: FieldDataInterface) => {
      //   this.fieldChange.emit(updatedField);
      // });
      // (this.componentRef.instance as any).menuClick.subscribe((item: FormsFieldItemMenuClick) => {
      //   this.menuClick.emit(item);
      // });
    }

    updateField() {
      if (this.componentRef) {
          (this.componentRef.instance as any).fieldSubmission = {...this.fieldSubmission};
      }
  }
}